import { InputGroup, InputLabel, TextInput } from '@components/Common';
import React from 'react';

interface Props {
  name: string;
  value: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
}

const DetailsInput: React.FC<Props> = ({ name, value, label, onChange, isDisabled }) => (
  <InputGroup>
    <InputLabel htmlFor={name}>{label}</InputLabel>
    <TextInput name={name} type="text" disabled={isDisabled} value={value || ''} onChange={onChange} />
  </InputGroup>
);

export default DetailsInput;
